/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StayDetail } from './StayDetail';
export type TourDetail = {
    tourId?: number;
    vanliferId?: number;
    name?: string;
    price?: number;
    rating?: number;
    status?: TourDetail.status;
    tourclass?: TourDetail.tourclass;
    statusDate?: number;
    serviceFee?: number;
    stays?: Array<StayDetail>;
    description?: string;
    sharingMode?: TourDetail.sharingMode;
    owner?: string;
    likeCount?: number;
    liked?: boolean;
    sasDownloadLink?: string;
};
export namespace TourDetail {
    export enum status {
        GENERATED = 'GENERATED',
        TAGGED = 'TAGGED',
        RESERVED = 'RESERVED',
        BOOKED = 'BOOKED',
        CANCELED = 'CANCELED',
    }
    export enum tourclass {
        CLASS0 = 'Class0',
        CLASS1 = 'Class1',
        CLASS2 = 'Class2',
    }
    export enum sharingMode {
        PRIVATE = 'PRIVATE',
        PUBLIC = 'PUBLIC',
    }
}

